import React from "react";
import { toKebabCase } from "../../helpers/cssHelper";
import { backstageChatStyle } from "../modules/ChatModule/helpers/chat.helper";

export function CatchWrapper({ children }) {
  try {
    return children;
  } catch (error) {
    return <h1>{error}</h1>;
  }
}

const backstageScrollStyle = `
.jir-scroll::-webkit-scrollbar {
  width: 9px !important;

}
.jir-scroll::-webkit-scrollbar-track {
  background: transparent !important;
}
.jir-scroll::-webkit-scrollbar-thumb {
  background-color: #4b4b4b !important;
  border-radius: 5px !important;
 
}
.jir-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #4b4b4b !important;
} `;

export function ScrollWrapper({ template, children, flexBasis = "100%", noStyleWrap = false, backstage = false, height }) {
  return (
    <div className={!noStyleWrap ? "styleWrapper" : ""} style={{ width: "100%", flexBasis, overflow: "hidden", height: height }}>
      {template ? <style>{`${toKebabCase(template.scrollbar, true, true)} `}</style> : null}
      {backstage ? <style>{backstageScrollStyle}</style> : null}
      {children}
    </div>
  );
}
